import { Controller } from '@hotwired/stimulus'

// Toggle controller for showing/hiding elements
// Usage: <div data-controller="toggle">
//          <button data-action="toggle#toggle">Toggle</button>
//          <div data-toggle-target="content" class="hidden">Content</div>
//        </div>
export default class extends Controller {
  static targets = ['content', 'icon']
  static classes = ['hidden', 'rotate']
  static values = {
    open: { type: Boolean, default: false }
  }

  connect () {
    if (this.openValue) {
      this.show()
    }
  }

  toggle () {
    this.openValue = !this.openValue

    if (this.openValue) {
      this.show()
    } else {
      this.hide()
    }
  }

  show () {
    if (this.hasContentTarget) {
      this.contentTarget.classList.remove(this.hiddenClass || 'hidden')
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.add(this.rotateClass || 'rotate-180')
    }
  }

  hide () {
    if (this.hasContentTarget) {
      this.contentTarget.classList.add(this.hiddenClass || 'hidden')
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove(this.rotateClass || 'rotate-180')
    }
  }
}
